import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { differenceHeroData } from './heroData'
import { DifferenceHeroCard } from './DifferenceHeroCard'
import clsx from 'clsx'
import classes from './DifferenceHero.module.scss'

export const DifferenceHero = () => {
  return (
    <Block
      as={'section'}
      variant={'shadowMob'}
      divider={'mobile'}
      className={classes.section}
    >
      <Block
        variant={'solidMob'}
        pad={'baseMob'}
        r={'md'}
        className={classes.content}
      >
        <hgroup className={classes.heading}>
          <Heading as={'h1'} size={'xxl'} center balance>
            Universal Integration Layer <br /> is the next generation of product
            integrations
          </Heading>
          <Text size={'lg'} balance center className={classes.subtitle}>
            We took the best from the previous generations of integration
            solutions and eliminated their critical flaws.
          </Text>
        </hgroup>
        <ul className={clsx('flex-column', classes.list)}>
          {differenceHeroData.map((item, idx) => (
            <DifferenceHeroCard key={idx} item={item} />
          ))}
        </ul>
      </Block>
    </Block>
  )
}
